var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"transform":"translate(-34.000000, 0.000000)","fill":"#000","fillRule":"nonzero"},React.createElement("polygon",{"points":"66.057 4.246 61.812 0.004 50.03 11.787 38.242 0 34 4.244 45.786 16.031 34.002 27.816 38.242 32.057 50.028 20.272 61.812 32.057 66.057 27.814 54.271 16.029"}))));
}

IconClose.defaultProps = {"width":"32px","height":"32px","viewBox":"0 0 32 32","version":"1.1"};

module.exports = IconClose;

IconClose.default = IconClose;
